const config = {
BASE_URL: "https://api.dev.vividdash.net",
// BASE_URL: "http://localhost:3001",


  //  BASE_URL:'https://dms.api.start-blocks.com',
  //   WEB_SOCKET_URL: "http://localhost:3004",
  //   WEB_SOCKET_URL:'https://dms.api.start-blocks.com',
  // AGENT_URL: "https://crm.atmc.org.in/sales-meeting/webservices/rest.php",
  // AGENT_API_KYE: "nslkfjsdjkfal45655647600000",
};
export default config;
